module.exports = __webpack_public_path__ + "img/3_bigw.8844838f.jpg";